import { Route, Routes, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import styled from 'styled-components';

import { ConfettiProvider } from '@components/confetti/provider';
import { RouteErrorBoundary } from '@components/route-error-boundary';
import { StepperSimple } from '@components/stepper-simple';
import { ThemeProvider } from '@components/theme-provider';
import { Toaster } from '@components/toaster';

import { useCurrentUser } from 'api/authentication/hooks';
import { useEditMyDetails } from 'api/users/hooks';
import { getRoutePaths, RouteMapper } from 'ui/helpers';

import { routes } from './routes';

export const routePaths = getRoutePaths([{ routes }]);

export const PreboardingCompanyNavigation = () => {
  const currentUser = useCurrentUser();

  return (
    <Container>
      <ConfettiProvider />
      <ThemeProvider app="journeys" theme={currentUser?.theme} updateTheme={useEditMyDetails}>
        <Routes>
          <Route path="*" element={<RouteConfig />} errorElement={<RouteErrorBoundary />} />
        </Routes>
        <Toaster />
      </ThemeProvider>
    </Container>
  );
};

const RouteConfig = () => {
  const currentUser = useCurrentUser();
  const defaultRoute = currentUser?.name ? routePaths.companyGetStarted : routePaths.setUserInfo;
  return <RouteMapper routes={routes} defaultRoute={defaultRoute} />;
};

const COMPANY_ONBOARDING_STEPS = [
  routePaths.companyGetStarted,
  routePaths.companyName,
  routePaths.companyEmployeeCount,
  routePaths.companyIndustry,
  routePaths.companyTheme,
];

export const useNextStep = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const currentIndex = COMPANY_ONBOARDING_STEPS.findIndex((step) => step === pathname);

  const handleContinue = () => {
    const nextStep = COMPANY_ONBOARDING_STEPS[currentIndex + 1];
    if (nextStep) {
      navigate(nextStep);
    }
  };

  return handleContinue;
};

export const CompanyPreboardingStepper = () => {
  const { pathname } = useLocation();

  const currentIndex = COMPANY_ONBOARDING_STEPS.findIndex((step) => step === pathname) - 1;
  return (
    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <StepperSimple totalSteps={COMPANY_ONBOARDING_STEPS.length - 2} activeIndex={currentIndex} />
    </div>
  );
};

const Container = styled.div({
  display: 'flex',
});
